import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { getLogout } from "redux/actions/UserLogout";
import { companyDetails } from "utils/companyDetails";
import {
  sideData,
  vendorSideData,
  customerSideData,
  subVendorSideData,
} from "./SideData";
import CompanyLogo from "assets/images/companyLogo.svg";

const drawerWidth = 247;

function SideNav(props) {
  // Define the data to be used based on the role
  const role = localStorage.getItem("role");
  const status = localStorage.getItem("status");
  const businessType = localStorage.getItem("businessType");
  let data =subVendorSideData;
  const dispatch = useDispatch();
  const location = useLocation();
  const currentActiveNav = location.pathname.split("/")[1];
  const { window, handleDrawerOpen, onlyMobile, onMobileOpen } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(() => {
    let idToSet = data?.find((obj) => obj.path === currentActiveNav)?.id;
    if (idToSet === undefined) {
      data?.forEach((obj) => {
        if (obj.submenu) {
          idToSet = obj.submenu.find(
            (subObj) => subObj.path === currentActiveNav
          )?.id;
        }
      });
    }
    return idToSet || 0;
  });

  const updateSelectedIndex = () => {
    const currentActiveNav = location.pathname.split("/")[1];
    let idToSet = data?.find((obj) => obj.path === currentActiveNav)?.id;
    if (idToSet === undefined) {
      data?.forEach((obj) => {
        if (obj.submenu) {
          idToSet = obj.submenu.find(
            (subObj) => subObj.path === currentActiveNav
          )?.id;
        }
      });
    }
    setSelectedIndex(idToSet || 0);
  };

  useEffect(() => {
    updateSelectedIndex();
  }, [location.pathname, data]);

  const [open, setOpen] = useState(false);
  const [drawerSize, setDrawerSize] = useState(247);
  const [dropdownOpenStates, setDropdownOpenStates] = useState(
    Array(data.length).fill(false)
  );
  const [selectedIcon, setSelectedIcon] = useState(null);

  const toggleDropdown = (index) => {
    const updatedStates = [...dropdownOpenStates];
    for (let i = 0; i < updatedStates.length; i++) {
      if (i !== index) {
        updatedStates[i] = false;
      }
    }
    updatedStates[index] = !updatedStates[index];
    setDropdownOpenStates(updatedStates);
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDrawerToggle = () => {
    handleDrawerOpen();
    setMobileOpen(!mobileOpen);
    setDesktopOpen(!desktopOpen);
    if (drawerSize === 247) {
      setDrawerSize(104);
    } else {
      setDrawerSize(247);
    }
  };

  const handleListItemClick = (event, index, field) => {
    localStorage.removeItem("complianceStatus");
    localStorage.removeItem("customerStatus");
    localStorage.removeItem("tripStatus");
    localStorage.removeItem("singleDriverStatus");
    localStorage.removeItem("subVendorStatus");
    localStorage.removeItem("singleSubStatus");
    localStorage.removeItem("vehicleStatus");
    localStorage.removeItem("vendorStatus");
    const subRouteIndex = [20, 14, 15, 16, 18, 19, 22, 23, 24, 40, 41];
    setSelectedIndex(index);
    if (field === "Logout") {
      dispatch(getLogout());
    } else if (
      dropdownOpenStates.includes(true) &&
      !subRouteIndex.includes(index)
    ) {
      setDropdownOpenStates([false]);
    }
  };

  const isDisabled = status === "Pending" || !role;

  const handelOnlyMobileDev = () => {
    onMobileOpen();
    setDrawerSize(247);
  };

  const drawer = (
    <div className="sidebarStyle">
      <Toolbar className="pl20">
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={onlyMobile ? handelOnlyMobileDev : handleDrawerToggle}
          md={{ mr: 2, display: { sm: "block" } }}
          className="pl25"
        >
          <MenuIcon className="iconColor" />
        </IconButton>
        {desktopOpen && (
          <img className="logoImage" src={companyDetails?.companyLogo} alt="CompanyLogo" />
        )}
      </Toolbar>
      <List className="listStyle">
        {data.map((sideData, index) => {
          if (sideData?.submenu) {
            const isDropdownOpen = dropdownOpenStates[index];
            return (
              <div key={sideData.id}>
                <ListItemButton
                  className={`${
                    selectedIndex === sideData.id
                      ? "activeSideNavStyle"
                      : "sideNavStyle"
                  } ${desktopOpen ? "paddingExpand" : "paddingCollapse"} ${
                    isDisabled ? "disabled" : ""
                  } `}
                  selected={selectedIndex === sideData.id}
                  onClick={() => toggleDropdown(index)}
                >
                  <ListItemIcon className="sideNavIcon">
                    {selectedIndex === sideData.id ? (
                      <img src={sideData?.activeIcon} alt="ActiveIcons" />
                    ) : (
                      <img src={sideData?.icon} alt="DashboardIcons" />
                    )}
                  </ListItemIcon>
                  {desktopOpen && <ListItemText primary={sideData.field} />}
                  {isDropdownOpen ? (
                    <ExpandLessOutlinedIcon />
                  ) : (
                    <ExpandMoreOutlinedIcon />
                  )}
                </ListItemButton>
                <Collapse
                  in={isDropdownOpen}
                  timeout="auto"
                  unmountOnExit
                  className="collapseBg"
                >
                  <List component="div" disablePadding>
                    {sideData.submenu.map((submenuItem, index) => (
                      <ListItemButton
                        key={submenuItem.id}
                        sx={{ pl: 4 }}
                        className={`sidenavDrop ${
                          selectedIndex === submenuItem.id
                            ? "activeSubmenu"
                            : "sidenavDrop"
                        } ${
                          desktopOpen ? "paddingExpand" : "paddingCollapse"
                        } ${isDisabled ? "disabled" : ""} `}
                        onClick={(event) =>
                          handleListItemClick(
                            event,
                            submenuItem.id,
                            submenuItem.field
                          )
                        }
                        component={Link}
                        to={"/" + submenuItem.path}
                      >
                        <ListItemIcon className="sideNavIcon">
                          {selectedIndex === submenuItem.id ? (
                            <img
                              src={submenuItem.activeIcon}
                              alt="ActiveIcons"
                            />
                          ) : (
                            <img src={submenuItem.icon} alt="DashboardIcons" />
                          )}
                        </ListItemIcon>
                        {desktopOpen && (
                          <ListItemText primary={submenuItem.field} />
                        )}
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </div>
            );
          } else if (sideData.field === "Logout") {
            // Render Logout button without the disabled style
            return (
              <ListItem
                name={sideData.field}
                key={sideData.id}
                className="sideNavStyle" // Remove the disabled style from Logout
                onClick={(event) =>
                  handleListItemClick(event, sideData.id, sideData.field)
                }
                component={Link}
                to={`/${sideData.path}`}
              >
                <ListItemIcon className="sideNavIcon">
                  {selectedIndex === sideData.id ? (
                    <img src={sideData.activeIcon} alt="ActiveIcons" />
                  ) : (
                    <img src={sideData.icon} alt="DashboardIcons" />
                  )}
                </ListItemIcon>
                {desktopOpen && (
                  <ListItemText
                    className="listIconStyle"
                    primary={sideData.field}
                  />
                )}
              </ListItem>
            );
          } else {
            return (
              <ListItem
                name={sideData.field}
                key={sideData.id}
                className={`${
                  selectedIndex === sideData.id
                    ? "activeSideNavStyle"
                    : "sideNavStyle"
                } ${desktopOpen ? "paddingExpand" : "paddingCollapse"} ${
                  isDisabled ? "disabled" : ""
                } `}
                onClick={(event) =>
                  handleListItemClick(event, sideData.id, sideData.field)
                }
                component={Link}
                to={
                  sideData.path === "rideTrack"
                    ? businessType === "isB2B"
                    ? `/${sideData.path}/2`
                    : `/${sideData.path}/1`
                    : sideData.path === "compliance"
                    ? role === "subVendorCompany"
                      ? `/${sideData.path}/3`
                      : `/${sideData.path}/2`
                    : `/${sideData.path}`
                }
              >
                <ListItemIcon className="sideNavIcon">
                  {selectedIndex === sideData.id ? (
                    <img src={sideData.activeIcon} alt="ActiveIcons" />
                  ) : (
                    <img src={sideData.icon} alt="DashboardIcons" />
                  )}
                </ListItemIcon>
                {desktopOpen && (
                  <ListItemText
                    className="listIconStyle"
                    primary={sideData.field}
                  />
                )}
              </ListItem>
            );
          }
        })}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div>
      <Box className="dflex">
        <Box
          component="nav"
          md={{
            width: { sm: drawerWidth },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="persistent"
            open={onlyMobile}
            onClose={handelOnlyMobileDev}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                borderRight: "0px",
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            open={desktopOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerSize,
                borderRight: "0px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </Box>
    </div>
  );
}

export default SideNav;
